import { Form, Select } from 'antd';
import { NamePath } from 'antd/lib/form/interface';

const fundingRoundCategories = [
  { value: 1, label: 'Other' },
  { value: 2, label: 'Seed / Angel' },
  { value: 3, label: 'Series A' },
  { value: 4, label: 'Series B' },
  { value: 5, label: 'Series C' },
  { value: 6, label: 'Series D' },
  { value: 7, label: 'Series E+' },
  { value: 8, label: 'Debt' },
  { value: 9, label: 'Grant' },
  { value: 10, label: 'IPO' },
  { value: 11, label: 'M&A' },
  { value: 12, label: 'Dead' },
  { value: 13, label: 'Private Equity' },
  { value: 14, label: 'Growth Equity' },
  { value: 15, label: 'Other Venture Capital' },
  { value: 16, label: 'Convertible Note' },
  { value: 17, label: 'N/A' },
  { value: 18, label: 'Divestitures' },
  { value: 19, label: 'Bankrupt' },
  { value: 20, label: 'Founder' },
  { value: 21, label: 'Valuation' },
];

export const CategoryFundingRoundsSelect = ({
  name,
  label,
  placeholder,
}: {
  name: NamePath;
  label: string;
  placeholder: string;
}) => {
  return (
    <Form.Item name={name} label={label}>
      <Select
        className="min-w-[200px]"
        mode="multiple"
        placeholder={placeholder}
        allowClear
        filterOption={(input, option) =>
          option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        options={fundingRoundCategories}
        labelInValue
      />
    </Form.Item>
  );
};
